import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetProjectModuleSubcontractorColumnChartValuesResultType,
    GetProjectModuleSubcontractorLineChartValuesResultType,
    GetProjectModuleSubcontractorMetricsValuesResultType,
    GetProjectModuleSubcontractorValuesResultType,
    ProjectSubcontractorClient,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ProjectSubcontractorService extends CustomReportServiceBase<
    ProjectSubcontractorClient,
    CustomReportServiceView
> {
    constructor(protected override client: ProjectSubcontractorClient) {
        super(client);
    }

    async getValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorValuesResultType[]> {
        return await lastValueFrom(this.client.projectSubcontractorGetProjectModuleSubcontractorValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(
            this.client.projectSubcontractorGetProjectModuleSubcontractorBoxesValues(parameters)
        );
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorColumnChartValuesResultType[]> {
        return await lastValueFrom(
            this.client.projectSubcontractorGetProjectModuleSubcontractorColumnChartValues(parameters)
        );
    }

    async getMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorMetricsValuesResultType> {
        return await lastValueFrom(
            this.client.projectSubcontractorGetProjectModuleSubcontractorMetricsValues(parameters)
        );
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorLineChartValuesResultType[]> {
        return await lastValueFrom(
            this.client.projectSubcontractorGetProjectModuleSubcontractorLineChartValues(parameters)
        );
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.projectSubcontractorSaveCatalogReport(body));
        else return await lastValueFrom(this.client.projectSubcontractorSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.projectSubcontractorGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.projectSubcontractorCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.projectSubcontractorGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.projectSubcontractorResultAvailableColumns(organizationIds));
    }
}
